import { useCallback, useContext } from "react";
import { fetch } from "../services/api";
// import { getCrossUpSelling, getItem as getItemQuery } from "../graphql/queries";
import useApi from "../hooks/useApi";
import { HotelContext } from "../context/hotel";


const useUpsell = () => {
    const { get } = useApi();
    const { data } = useContext(HotelContext);

    const getUpsellingList = async () => {
        try {
            const response = await get(`hotels/${data.id}/upselling`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getUpselling = async (itemId) => {
        try {
            const response = await get(`hotels/${data.id}/upselling/${itemId}`);
            console.log('response', response)
            return response;

        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };



    const getUpsellingShortToList = async () => {
        try {
            const response = await get(`hotels/${data.id}/upselling/to_list`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getBookableIdbyItembyId = useCallback((id) => {
        console.log('TODO - getBookableIdbyItembyId')
        // return fetch(getItemQuery, {
        //     id: id,
        // }).then((r) => r.data.getItem.bookableItemId || false);
    }, []);

    return {
        getUpsellingList,
        getUpselling,
        getBookableIdbyItembyId,
        getUpsellingShortToList
    };
};

export default useUpsell;
